module.exports = __webpack_public_path__ + "static/media/RobLaMagnaReiter.89edddcd.png";